/**
 * Canonicalize old v1 translation IDs to their v2 IDs.
 */
const legacyTranslationIds: Record<string, string> = {
  aov: "afr1953",
  dsv: "sv1750",
  esv: "esv2001",
  frc: "neg1979",
  fs21: "sg21",
  hcsb: "hcsb2004",
  kjv: "kjv1611",
  nasb: "nasb1995",
  nbg: "nbg1951",
  grk: "sblg2010",
  heb: "wlc1982",
  sblg: "sblg2010",
  wlc: "wlc1982",
};

/**
 * Canonicalize old v1 translation IDs to their v2 IDs.
 */
export function canonicalizeTranslationId(tid: string): string {
  return legacyTranslationIds[tid] ?? tid;
}
